/**
 * Form validation utilities
 */

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return { valid: false, message: 'Email is required' };
  if (!emailRegex.test(email)) {
    return { valid: false, message: 'Please enter a valid email address' };
  }
  return { valid: true, message: '' };
};

export const validatePhone = (phone) => {
  if (!phone) return { valid: true, message: '' }; // Phone is optional
  
  // Remove spaces, dashes, and parentheses
  const cleaned = phone.replace(/[\s\-\(\)]/g, '');
  
  // Check if it starts with +255 (Tanzania) or 0, and has 9-12 digits
  const tzPhoneRegex = /^(\+255|0)?[0-9]{9,12}$/;
  
  if (!tzPhoneRegex.test(cleaned)) {
    return { valid: false, message: 'Please enter a valid phone number' };
  }
  return { valid: true, message: '' };
};

export const validateName = (name) => {
  if (!name || name.trim().length < 2) {
    return { valid: false, message: 'Name must be at least 2 characters' };
  }
  if (name.trim().length > 100) {
    return { valid: false, message: 'Name is too long' };
  }
  return { valid: true, message: '' };
};

export const validateMessage = (message, minLength = 10) => {
  if (!message || message.trim().length < minLength) {
    return { valid: false, message: `Message must be at least ${minLength} characters` };
  }
  return { valid: true, message: '' };
};

export const validateDate = (dateString, minDaysAhead = 1) => {
  if (!dateString) return { valid: false, message: 'Date is required' };
  
  const selectedDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const minDate = new Date(today);
  minDate.setDate(minDate.getDate() + minDaysAhead);
  
  if (selectedDate < minDate) {
    return { valid: false, message: `Date must be at least ${minDaysAhead} day(s) in advance` };
  }
  
  const maxDate = new Date(today);
  maxDate.setMonth(maxDate.getMonth() + 3);
  
  if (selectedDate > maxDate) {
    return { valid: false, message: 'Date cannot be more than 3 months in advance' };
  }
  
  return { valid: true, message: '' };
};

export const validateTime = (timeString, dateString) => {
  if (!timeString) return { valid: false, message: 'Time is required' };
  
  if (!dateString) return { valid: true, message: '' }; // Can't validate time without date
  
  const selectedDate = new Date(dateString);
  const dayOfWeek = selectedDate.getDay();
  
  // Saturday hours end earlier
  if (dayOfWeek === 6) {
    const [hours, minutes] = timeString.split(':').map(Number);
    if (hours > 18 || (hours === 18 && minutes > 0)) {
      return { valid: false, message: 'Saturday appointments end at 6:00 PM' };
    }
  }
  
  return { valid: true, message: '' };
};


